import { getDomain } from '@/utils/getDomain';
import { getUrl } from '@/utils/getUrl';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { isProduction } from 'lib/labrador/utils';

const shouldUseV2Auth = getOcelotConfig('features.login.v2.enabled');

export const getAipAccountUrl = () => {
  return isProduction ? 'https://account.allerid.com/' : 'https://account-dev.allerid.com/';
};

export const getUserAuthUrl = () => {
  if (shouldUseV2Auth) {
    return getDomain(false);
  }
  return isProduction ? 'https://login.allermedia.se' : 'https://login-stage.allermedia.se';
};

const getAuthUrlFactory = (path?: string) => (params?: Record<string, string>) => {
  const url = getUrl(path ?? '', getUserAuthUrl());
  const searchParams = new URLSearchParams(params ?? { return: getDomain(false) });

  if (!url) {
    throw Error('Unable to get user auth url');
  }

  url.search = searchParams.toString();

  return url.href;
};

const getBrandName = (() => {
  let cached: string | null = null;
  return () => (cached ??= getOcelotConfig('features.login.v1.brandName'));
})();

export const getUserLogInUrl = (params?: Record<string, string>) => {
  return shouldUseV2Auth ? getAuthUrlFactory('/api/auth/login')(params) : getAuthUrlFactory()(params);
};

export const getUserSignUpUrl = (params?: Record<string, string>) => {
  return shouldUseV2Auth ? getAuthUrlFactory('/api/auth/login')(params) : getAuthUrlFactory('/nytt-konto')(params);
};

export const getUserPageUrl = (params?: Record<string, string>) => {
  if (shouldUseV2Auth) {
    const url = getUrl('/settings', getAipAccountUrl());
    return url?.href;
  }
  return getAuthUrlFactory('/mina-sidor')(params);
};

export const getUserLogOutUrl = (params?: Record<string, string>) => {
  return shouldUseV2Auth
    ? getAuthUrlFactory('/api/auth/logout')(params)
    : getAuthUrlFactory(`/logout/${getBrandName()}`)(params);
};

export const getUserPasswordlessUrl = (params?: Record<string, string>) => {
  if (shouldUseV2Auth) {
    throw new Error('getUserPasswordlessUrl is not supported in v2 auth system');
  }
  return getAuthUrlFactory('/account/passwordless')(params);
};

export const getPasswordResetPageUrl = (params?: Record<string, string>) => {
  if (shouldUseV2Auth) {
    const url = getUrl('/recovery', getAipAccountUrl());
    return url?.href;
  }
  return getAuthUrlFactory('/aterstall-losenord')(params);
};
